import { render, staticRenderFns } from "./RecommendPageCard.vue?vue&type=template&id=0faa7eeb"
import script from "./RecommendPageCard.vue?vue&type=script&lang=js"
export * from "./RecommendPageCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports